/**
 * Extracted from `components/grading/partial-completion-mark.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { cn } from "@/lib/utils"

export const PARTIAL_COMPLETION_SLOT_CLASS = cn(
  "inline-flex size-6 min-h-6 min-w-6 shrink-0 items-center justify-center",
)
